module.exports = __webpack_public_path__ + "static/img/img-card-big-bike-v1.324158a.jpg";